import React, { memo } from 'react';
import { Grid, Link, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useTranslation } from 'i18n';
import { routes } from 'utils/routing';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  title: string;
  organization: any;
}

const useStyles = makeStyles()((theme) => ({
  companyTitle: {
    marginTop: theme.spacing(3),
  },
  linkText: {
    textTransform: 'uppercase',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}));

const OrgEventsTop: React.FC<React.PropsWithChildren<IProps>> = ({ title, organization }) => {
  const { classes } = useStyles();
  const [t] = useTranslation('public');

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container alignItems="center" justifyContent="flex-start">
          <ArrowBackIosIcon fontSize="small" color="primary" />
          <Grid item>
            <Link href={routes.organizationProfile(organization.id).link} className={classes.linkText}>
              {t<string>('screen.organizationEvents.backToProfile')}
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary" className={classes.companyTitle}>
          {organization.title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4">{title}</Typography>
      </Grid>
    </Grid>
  );
};

export default memo(OrgEventsTop);
